import { render, staticRenderFns } from "./PRNDL.vue?vue&type=template&id=2993ffea&scoped=true&"
import script from "./PRNDL.vue?vue&type=script&lang=js&"
export * from "./PRNDL.vue?vue&type=script&lang=js&"
import style0 from "./PRNDL.vue?vue&type=style&index=0&id=2993ffea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993ffea",
  null
  
)

export default component.exports